import angular from 'angular';
import Rx from 'rx';

export default function UserService($wamp, $localstorage) {

  let user = {};
  let loggedIn = false;
  let subject = new Rx.ReplaySubject(1);
  let roles = new Rx.BehaviorSubject([]);

  function load() {
    return $wamp.call('org.eggs.get_user_info', [])
        .then(function (res) {
          loggedIn = true;
          angular.extend(user, res);
          subject.onNext(res);
          return res;
        });
  }

  return {
    get: function () {
      return user;
    },
    load: load,
    subject: subject.combineLatest(roles, function (u, r) {
      u.roles = r;
      return u;
    }),
    setRoles: function (r) {
      roles.onNext(r);
    },
    loggedIn: function () {
      return loggedIn;
    },
    logout: () => {
      $localstorage.del('ecitoken');
      $localstorage.del('authid');
      $localstorage.del('masqtoken');
      $localstorage.del('masqauthid');

      location.reload();
    }
  };
}
